export const ControlErrorCode = {
  INVALID_PATH: "INVALID_PATH",
  PATH_NOT_FOUND: "PATH_NOT_FOUND",
  PATH_NOT_DIRECTORY: "PATH_NOT_DIRECTORY",
  PATH_ACCESS_DENIED: "PATH_ACCESS_DENIED",
  PROXY_OFFLINE: "PROXY_OFFLINE",
  PROXY_NOT_FOUND: "PROXY_NOT_FOUND",
  PROXY_ONLINE: "PROXY_ONLINE",
  SESSION_NOT_FOUND: "SESSION_NOT_FOUND",
  SESSION_ALREADY_ACTIVE: "SESSION_ALREADY_ACTIVE",
  PROVIDER_UNSUPPORTED: "PROVIDER_UNSUPPORTED",
  APPROVAL_POLICY_UNSUPPORTED: "APPROVAL_POLICY_UNSUPPORTED",
  WORKER_START_FAILED: "WORKER_START_FAILED",
  PROCESS_START_FAILED: "PROCESS_START_FAILED",
  STREAM_CAPACITY_EXCEEDED: "STREAM_CAPACITY_EXCEEDED",
  CONTROL_LEASE_INVALID: "CONTROL_LEASE_INVALID",
  OPERATION_CONFLICT: "OPERATION_CONFLICT",
  RATE_LIMITED: "RATE_LIMITED",
  UNKNOWN: "UNKNOWN",
} as const;

export type ControlErrorCode = (typeof ControlErrorCode)[keyof typeof ControlErrorCode];
